<div class="header-buffer"></div>
<div class="content">
  <div class="content-titles">
    <div class="categories-title title-div">
      {{ 'enterpriseAiDashboardPage.m365copilotTopPluginsDisplayNameTitle' | labelsProvider }}
    </div>
    <div class="sub-categories">
      <div class="sub-categories-title title-div">
        {{ 'enterpriseAiDashboardPage.m365copilotTopPluginsTypeTitle' | labelsProvider }}
      </div>
      <div class="sub-categories-title title-div">
        {{ 'enterpriseAiDashboardPage.m365copilotTopPluginsInteractionsTitle' | labelsProvider }}
      </div>
    </div>
  </div>
  <div class="content-items">
    <div *ngFor="let item of seriesData" class="content-item">
      <div class="category-name">
        {{ item.displayName }}
      </div>
      <div class="amountPerSubCategory">
        <div class="item plugin-type">
          {{ transformPluginTypeText(item.categoryName) }}
        </div>
        <div class="item plugin-interactions">
          {{ getSubCategoryAmount(item.amountPerSubCategory, 'interactions') }}
        </div>
      </div>
    </div>
  </div>
</div>
